import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import LoadingSpinner from '../common/LoadingSpinner';

const EventRegistrations = () => {
	const [rows, setRows] = useState([]);
	const [loading, setLoading] = useState(true);
	const [search, setSearch] = useState('');

	useEffect(() => {
		const load = async () => {
			try {
				setLoading(true);
				const r = await api.get('/events/registrations');
				setRows(r.data.data || []);
			} finally {
				setLoading(false);
			}
		};
		load();
	}, []);

	const filtered = rows.filter((r) => {
		const q = search.toLowerCase();
		return (
			(r.fullName || '').toLowerCase().includes(q) ||
			(r.email || '').toLowerCase().includes(q) ||
			(r.phoneNumber || '').toLowerCase().includes(q) ||
			(r.organizationName || '').toLowerCase().includes(q)
		);
	});

	return (
		<div className="container mx-auto px-4 py-6">
			<div className="flex items-center justify-between mb-4">
				<h2 className="text-xl font-semibold">Event Registrations</h2>
				<input className="form-input w-64" placeholder="Search" value={search} onChange={(e) => setSearch(e.target.value)} />
			</div>
			<div className="bg-white rounded-lg shadow-soft overflow-hidden">
				{loading ? (
					<div className="p-6 flex justify-center"><LoadingSpinner /></div>
				) : filtered.length === 0 ? (
					<div className="p-6 text-center text-gray-500">No registrations</div>
				) : (
					<div className="overflow-x-auto">
						<table className="min-w-full divide-y divide-gray-200">
							<thead className="bg-gray-50">
								<tr>
									<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
									<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Contacts</th>
									<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Org / Role</th>
									<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Sector</th>
									<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">County</th>
									<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
								</tr>
							</thead>
							<tbody className="bg-white divide-y divide-gray-200">
								{filtered.map((r) => (
									<tr key={r._id}>
										<td className="px-6 py-4">{r.fullName}</td>
										<td className="px-6 py-4">
											<div>{r.email}</div>
											<div className="text-sm text-gray-600">{r.phoneNumber}</div>
										</td>
										<td className="px-6 py-4">
											<div>{r.organizationName}</div>
											<div className="text-sm text-gray-600">{r.roleTitle}</div>
										</td>
										<td className="px-6 py-4">{r.industrySector}</td>
										<td className="px-6 py-4">{r.county}</td>
										<td className="px-6 py-4">
											<span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${r.status==='paid'?'bg-green-100 text-green-800': r.status==='failed'?'bg-red-100 text-red-800':'bg-yellow-100 text-yellow-800'}`}>{r.status}</span>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				)}
			</div>
		</div>
	);
};

export default EventRegistrations;


